import React, { useEffect, useState, useRef } from 'react';
import { Scanner } from '@yudiel/react-qr-scanner/dist/cjs';
import caretLeft from '../../../../assets/icons/ic_caret_left.svg';
import { useDictionary } from '../../../../utilities/hooks/UseDictionary';
import PropTypes from 'prop-types';
import useClientWidth from '../../../../utilities/hooks/useClientWidth';

const QRScanner = ({ onScanSuccess, setShowBoxFilter, setShowScanner, qrSuccess,setBookingDetails,setQrSuccess}) => {
    const [scanError, setScanError] = useState('');
    const [cameraAvailable, setCameraAvailable] = useState(false);
    const mediaStreamRef = useRef(null);
    const dictionary = useDictionary();
    const width = useClientWidth();

    const backToFilterList = () => {
        setShowBoxFilter(true);
        setShowScanner(false);
        setBookingDetails(null);
        setQrSuccess(false);
        stopMediaStream();
    };
    const stopMediaStream = () => {
        if (mediaStreamRef.current) {
            mediaStreamRef.current.getTracks().forEach(track => track.stop());
            mediaStreamRef.current = null;
        }
    };
    const requestCameraPermission =async () => {
        if (navigator?.mediaDevices && navigator?.mediaDevices?.getUserMedia) {
            try {
                const stream = await navigator.mediaDevices.getUserMedia({
                    video: {
                        height: { ideal: 720 },
                        width: { ideal: 1280 },
                        facingMode: 'environment',
                    },
                });
                mediaStreamRef.current = stream;
                return stream;
            } catch(err) {
                setScanError(`Camera access was denied: ${err.message}`);
                return null;
            }
        } else {
            setScanError('Your browser does not support camera access.');
            return null;
        }
    };
    useEffect(() => {
        const initializeCamera = async () => {
            const stream = await requestCameraPermission();
            if (stream) {
                const devices = await navigator.mediaDevices.enumerateDevices();
                const hasCamera = devices.some(device => device.kind === 'videoinput');
                setCameraAvailable(hasCamera);
                if (!hasCamera) {
                    setScanError('No camera device found. Please ensure your camera is connected and try again.');
                }
            }
        };

        const handleVisibilityChange = () => {
            if (document.hidden && width <= 767) {
                stopMediaStream();
                setShowBoxFilter(true);
                setShowScanner(false);
                setBookingDetails(null);
                setQrSuccess(false);
            }
        };

        document.addEventListener('visibilitychange', handleVisibilityChange);
        initializeCamera().catch(error => {
            console.error('Error initializing camera:', error);
            setScanError('Failed to initialize the camera.');
        });
    
        return () => {
            document.removeEventListener('visibilitychange', handleVisibilityChange);
            stopMediaStream();
        };
    }, []);

    const handleScan = (result) => {
        if (result) {
            onScanSuccess(result);
            setScanError('')
        }
    };

    const handleError = async(error) => {
        let errorMessage = 'An unknown error occurred.';
        if (error.name === 'NotAllowedError') {
            errorMessage = 'Camera access was denied. Please allow camera access and try again.';
            await navigator?.mediaDevices?.getUserMedia({ video: true });
        } else if (error.name === 'NotFoundError' || error.name === 'DevicesNotFoundError') {
            errorMessage = 'No camera device found. Please ensure your camera is connected and try again.';
        } else if (error.name === 'NotReadableError' || error.name === 'TrackStartError') {
            errorMessage = 'Camera is already in use or not accessible. Please close other applications using the camera and try again.';
        } else if (error.message.includes('Loading camera stream timed out after')) {
            errorMessage = 'Camera is already in use or not accessible. Please close other applications using the camera and try again.';
        } else {
            errorMessage = error.message;
        }
        setScanError(errorMessage);
    };

    return (
        <div>
            <a href="#" onClick={backToFilterList} className="back-to-filter-list">
                <img src={caretLeft} alt="Back" />
                <span>{dictionary.back}</span>
            </a>
            {
                cameraAvailable && scanError == '' && qrSuccess == false ? (
                    <Scanner
                        onScan={handleScan}
                        scanDelay={3000}
                        onError={handleError}
                        allowMultiple={true}
                        styles={{
                            container: { width: '320px', height: '240px' },
                            video: { borderRadius: '10px' },
                        }}
                    />
                ) : null
            }
            {
               scanError && (
                    <div className="input-error-message" style={{ fontSize: 14 }}>
                        {scanError}
                    </div>
                )
            }
        </div>
    );
};

QRScanner.propTypes = {
    onScanSuccess: PropTypes.func.isRequired,
    setShowBoxFilter: PropTypes.func.isRequired,
    setShowScanner: PropTypes.func.isRequired,
    setBookingDetails: PropTypes.func,
    setQrSuccess: PropTypes.func,
    qrSuccess: PropTypes.bool
};

export default QRScanner;
